/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";
import { handleCustomNoteFilling } from "../Preferences/usePreferences";
import { normalize } from "utils/capitalize";
export const GENERAL_ALLERGIES_OPTIONS = [
  "pollen",
  "flowers",
  "chemicals",
  "latex",
  "cotton",
  "other",
];

const useGeneralAllergies = (companion) => {
  /* const { t } = useTranslation(); */
  const [hasChemicalAllergies, setHasChemicalAllergies] = useState(false);

  const [formData, setFormData] = useState(() =>
    GENERAL_ALLERGIES_OPTIONS.reduce((sum, key) => {
      return { ...sum, [key]: { state: "initial", value: key } };
    }, {})
  );
  const [customAllergy, setCustomAllergy] = useState("");
  const [chemicalAllergies, setChemicalAllergies] = useState("");
  useEffect(() => {
    if (!companion) return;
    const _generalAllergies = companion.general_allergies?.split(",");
    const customNote = handleCustomNoteFilling(companion?.general_allergies);
    if (customNote) {
      setCustomAllergy(customNote);
    }
    _generalAllergies?.forEach((allergy) => {
      if (allergy.startsWith("other:")) return;
      setFormData((prev) => {
        const safePref = normalize(allergy);
        return { ...prev, [allergy]: { state: "success", value: safePref } };
      });

      setChemicalAllergies(companion.chemical_allergies);
    });
  }, [companion]);

  const handleOnChange = (text) => {
    setFormData((prev) => {
      if (formData[text]?.state === "success") {
        return { ...prev, [text]: { value: text, state: "initial" } };
      }
      return { ...prev, [text]: { value: text, state: "success" } };
    });
  };

  useEffect(() => {
    if (formData.chemicals?.state == "success") {
      setHasChemicalAllergies(true);
    } else {
      setHasChemicalAllergies(false);
      setChemicalAllergies("");
    }
  }, [formData]);
  return {
    customAllergy,
    handleOnChange,
    formData,
    setCustomAllergy,
    hasChemicalAllergies,
    chemicalAllergies,
    setChemicalAllergies,
  };
};

export default useGeneralAllergies;
